import { render, staticRenderFns } from "./LmFormSubtitles.vue?vue&type=template&id=9fcb380a&"
import script from "./LmFormSubtitles.vue?vue&type=script&lang=js&"
export * from "./LmFormSubtitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports